const $$splitComponentImporter = () => import('/home/runner/work/touring-host-app/touring-host-app/src/routes/_rootLayout/companies/$id.general.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { getFindCompanySitesSuspenseQueryOptions, getFindCompanySuspenseQueryOptions } from '@api';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/_rootLayout/companies/$id/general')({
  loader: async ({
    context: {
      queryClient
    },
    params
  }) => {
    queryClient.ensureQueryData(getFindCompanySuspenseQueryOptions(params.id));
    queryClient.ensureQueryData(getFindCompanySitesSuspenseQueryOptions(params.id));
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});